const { disableBodyScroll, clearAllBodyScrollLocks } = window.bodyScrollLock;

const toggleShareListing = e => {
  e.stopImmediatePropagation();
  e.preventDefault();
  const share_modal_container = $('#share_modal_container');

  share_modal_container.toggleClass('hidden');

  if (share_modal_container.hasClass('hidden')) {
    clearAllBodyScrollLocks();
    $('body').css('overflow', '');
  } else {
    disableBodyScroll(share_modal_container);
  }
};

$(() => {
  const share_button = $('.share_listing');
  const share_modal_backdrop = $('#share_modal_backdrop');
  const close_modal = $('.close-modal.share');
  // Show share listing modal
  share_button.on('click', toggleShareListing);
  // Hide share listing modal
  share_modal_backdrop.on('click', toggleShareListing);
  close_modal.on('click', toggleShareListing);
});
